import SplitType from "split-type";
import React, { useRef, useLayoutEffect, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

const AnimatedLine = ({ para }) => {

   const paraRef = useRef();

   gsap.registerPlugin(useGSAP);
   gsap.registerPlugin(ScrollTrigger);

   useGSAP(() => {



      ScrollTrigger.matchMedia({
         "(min-width: 768px)": function () {

            const split = new SplitType(paraRef.current, {
               types: "lines",
               lineClass: "line-child", // Automatically wraps lines in spans
            });


            gsap.fromTo(
               ".line-child",
               {
                  opacity: 0, filter: "blur(10px)", y: 20,
                  letterSpacing: '-0.5px',
               },
               {
                  opacity: 1,
                  letterSpacing: '-0.5px',
                  filter: "blur(0px)",
                  y: 0,
                  duration: 1,
                  stagger: 0.2,
                  ease: "power2.out",
                  scrollTrigger: {
                     trigger: paraRef.current,
                     start: "top 50%",
                     //toggleActions: "play none none reverse",
                     toggleActions: "play reverse play reverse",
                     //markers: true,
                  },
               }
            );
         }
      })

   }, {})

   useEffect(() => {
      setInterval(() => {
         ScrollTrigger.refresh()
      }, [1500])
   }, [])

   return (
      <p ref={paraRef}>
         {para}
      </p>
   )
}
export default AnimatedLine;